// @flow
import React from 'react';
import moment from 'moment';
import { DatePicker } from '../../../components/ant/DatePicker';

import CommonForm, {
  type CommonFormProps,
} from '../../../components/hoc/common/handbook/CommonForm';
import type { TripInspectionCost } from '../../../lib/types';
import Grid, { GridItem } from '../../../components/layout/Grid';
import { FormField } from '../../../components/Form';
import { StyledInput } from '../../../components/hoc/common/components/elements';
import { OrgUnitSelect } from '../../../components';
import { ApproveYesNoSelect } from '../../../components/selects/AutoGeneratedEnumSelects';

export default (props: CommonFormProps<$Shape<TripInspectionCost>>) => {
  return (
    <CommonForm {...props}>
      {({ setFieldValue, values }) => {
        return (
          <>
            <Grid gutter="16px">
              <GridItem>
                <FormField label="Ключ" fast required name="key">
                  {({ name, value }) => <StyledInput disabled value={value} />}
                </FormField>
              </GridItem>
              <GridItem>
                <FormField label="Значение" fast required name="value">
                  {({ name, value }) => (
                    <StyledInput
                      name={name}
                      value={value}
                      onChange={(e) => setFieldValue(name, e.target.value)}
                    />
                  )}
                </FormField>
              </GridItem>
            </Grid>
          </>
        );
      }}
    </CommonForm>
  );
};
